(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/Model', 'services/portalUserExtService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var portalUserExtService = require('./../urls').portalUserExtService;
    module.exports = factory(require('backbone-torso/modules/Model'), portalUserExtService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoModel, portalUserExtService) {
  'use strict';
  /**
   * Model for count of unread messages a user has.
   *
   * @class MessageCountsModel
   * @constructor
   * @extends Torso.TorsoModel
   */
  return TorsoModel.extend({
    url: function() {
      return portalUserExtService + '/current~/messages';
    }
  });
}));
